import { createTheme } from '@mui/material';
import ezTheme from './ezTheme';
var ezMarketplaceTheme = createTheme(ezTheme, {});
export default ezMarketplaceTheme;